import React from 'react';

import styles from './MiniLogo.module.scss';
import logo from '../../../assets/img/minilogo.png';

const miniLogo = props => (
    <div className={styles.miniLogo}>
        <img width={props.width} src={logo} alt='mini Logo'></img>
    </div>
);

export default miniLogo;